import { StorageRetryPolicyType } from '@azure/storage-blob';
export function retryOptionsFactory(initialDelay) {
    return {
        maxTries: 4,
        tryTimeoutInMs: 30 * 1000,
        retryDelayInMs: initialDelay,
        maxRetryDelayInMs: 10 * 1000,
        retryPolicyType: StorageRetryPolicyType.EXPONENTIAL,
    };
}
